var _rect, _rect2, _circle, _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStudentCouncilBoardPage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 78,
    height: 66,
    viewBox: "0 0 78 66",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 51.5229,
    width: 51,
    height: 7,
    fill: "url(#paint0_linear_4691_18691)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 58.5229,
    width: 69,
    height: 7,
    fill: "url(#paint1_linear_4691_18691)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.4085,
    cy: 15.9319,
    r: 11,
    transform: "rotate(-52.9066 15.4085 15.9319)",
    fill: "url(#paint2_linear_4691_18691)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7125 27.3277C19.7644 26.6852 19.5484 25.3793 20.2392 24.4658L24.9136 18.2836C25.6126 17.3592 26.9484 17.2205 27.8223 17.9815L45.5789 33.4438C46.0841 33.8837 46.3479 34.5509 46.2102 35.2064C45.7032 37.6202 44.5769 39.191 42.1254 40.5995C41.503 40.9571 40.7322 40.8945 40.138 40.4918L20.7125 27.3277Z",
    fill: "url(#paint3_linear_4691_18691)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6689 26.0483L26.3032 17.2741",
    stroke: "#DDEBF6",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30 34.2964L36.6343 25.5222",
    stroke: "#DDEBF6",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31 49.5229L31 33.5229",
    stroke: "#DDEBF6",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4691_18691",
    x1: 19.5,
    y1: 47.5229,
    x2: 17.6374,
    y2: 68.5334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDEBF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4691_18691",
    x1: 9,
    y1: 64.0229,
    x2: 19.6018,
    y2: 88.1553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDEBF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4691_18691",
    x1: 15.4085,
    y1: 4.93185,
    x2: 41.1187,
    y2: 24.0539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDEBF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4691_18691",
    x1: 22.5874,
    y1: 21.3601,
    x2: 39.5396,
    y2: 9.38968,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDEBF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentCouncilBoardPage);
export default __webpack_public_path__ + "static/media/studentCouncil-board-page.199faa45742383e4c6583ccc508746ae.svg";
export { ForwardRef as ReactComponent };